/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Restore_ButtonInputs */

const en_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore`)
};

const fr_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurer`)
};

const de_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederherstellen`)
};

const it_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristinare`)
};

const ru_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить`)
};

const es_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar`)
};

const zh_cn2_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复`)
};

const ja_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復元する`)
};

const hi_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुनर्स्थापित करना`)
};

const pt_pt2_automatic_save_restore_button = /** @type {(inputs: Automatic_Save_Restore_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar`)
};

/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Automatic_Save_Restore_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_button = /** @type {((inputs?: Automatic_Save_Restore_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_restore_button(inputs)
	if (locale === "de") return de_automatic_save_restore_button(inputs)
	if (locale === "it") return it_automatic_save_restore_button(inputs)
	if (locale === "ru") return ru_automatic_save_restore_button(inputs)
	if (locale === "es") return es_automatic_save_restore_button(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_restore_button(inputs)
	if (locale === "ja") return ja_automatic_save_restore_button(inputs)
	if (locale === "hi") return hi_automatic_save_restore_button(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_restore_button(inputs)
	return en_automatic_save_restore_button(inputs)
});